<div class="modal fade" id="basketModal" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-lg modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">{{ 'download' | transloco }}</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <adl-loading [isLoading]="isLoading">
        <div class="modal-body">
          @for (type of DownloadFileFormatEnum|keyvalue; track type) {
          <div class="form-check">
            <input class="form-check-input" [id]="type.key" type="radio" [(ngModel)]="format" [value]="type.key" />
            <label class="form-check-label" [for]="type.key">
              {{ 'measurement.download_' + type.key | transloco }}
            </label>
          </div>
          }
        </div>
        <div class="modal-footer">
          <button class="btn btn-outline-secondary" (click)="closeModal()">
            {{ 'cancel' | transloco }}
          </button>
          <button class="btn btn-danger" (click)="download()" [disabled]="!format">
            {{ 'confirm' | transloco }}
          </button>
        </div>
      </adl-loading>
    </div>
  </div>
</div>
